import AbstractApiActionTypes from "services/cores/abstractApiActionTypes";

const AvailableParkingActionTypes = new AbstractApiActionTypes(
  "availableParking"
);

export default AvailableParkingActionTypes;
